// extracted by mini-css-extract-plugin
export var linkText = "_oa-0";